<template>
  <div class="massUpload">
    <div class="outerLayer">
      <div class="outerLayer_titleArea">
        <div class="adesr">
          <div class="item">
            <!-- <span class="item_title">广告主ID</span>
            <el-input
              v-model.trim="parameter.account_id"
              class="item_input"
              placeholder="请输入"
            />
            <el-button
              icon="el-icon-search"
              circle
              type="primary"
              @click="search_noid"
            /> -->
            <!-- <div style="margin: 10px">
              <span class="item_title">用户行为数据源</span>
              <el-select
                v-model="parameter.user_action_sets"
                :disabled="delaytypearr.length===0"
                multiple
                allow-create
                filterable
                placeholder="请先输入广告主id"
              >
                <el-option
                  v-for="items in delaytypearr"
                  :key="items.asset_id"
                  :label="`${items.name}(${items.asset_id})/${items.access_way_text}`"
                  :value="items.asset_id"
                />
              </el-select>
            </div> -->
            <!-- <div style="margin: 10px">
              <el-button
                icon="el-icon-download"
                class="filter-item"
                type="success"
                @click="pullAll"
              >批量更新用户QQ下广告主的行为数据源</el-button>
            </div> -->
            <div class="item">
              <span class="title">用户行为数据源id：</span>
              <div style="flex: 1">
                <el-tag
                  v-for="tag in keyWordsObj"
                  :key="tag"
                  style="margin-right: 10px"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                >
                  {{ tag }}
                </el-tag>
                <el-input
                  v-if="inputVisible"
                  ref="saveTagInput"
                  v-model="inputValue"
                  class="input-new-tag"
                  size="small"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                />
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput"
                >+ 新建关键词</el-button>
              </div>
            </div>
            <!-- <div class="item">
              <span
                style="margin-left: 200px"
                class="title"
              >拉取广告时间范围：</span>
              <div style="flex: 1">
                <div class="block">
                  <el-date-picker
                    v-model="date"
                    type="daterange"
                    align="right"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  />
                </div>
              </div>
            </div> -->
            <div class="item" style="margin-left: 20px">
              <el-button type="success" @click="materialSyncbut">
                同步资产
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="shuttle-box">
        <div class="left-panel">
          <div style="margin: 10px">
            <div style="display: inline">
              <span class="item_title">选中类型</span>
              <el-select
                v-model="advertiser.type"
                placeholder="请选择"
                @change="changeselect"
              >
                <el-option label="广告" :value="1" />
                <el-option label="广告主" :value="2" />
              </el-select>
            </div>
            <div style="display: inline">
              <span class="item_title">广告主ID</span>
              <el-input
                v-model.trim="advertiser.account_id"
                style="width: 150px; margin-right: 10px"
                placeholder="请输入广告主ID"
              />
              <!-- <el-autocomplete
                v-model="advertiser.account_id"
                :fetch-suggestions="querySearchAsyncPlatformid"
                placeholder="请输入广告主ID"
                style="margin-right:20px"
                @select="handleSelectPlatform"
              /> -->
              <span class="item_title">广告主名称</span>
              <el-input
                v-model.trim="advertiser.account_name"
                style="width: 150px"
                placeholder="请输入广告主名称"
              />
              <!-- <el-autocomplete
                v-model="advertiser.account_name"
                :fetch-suggestions="querySearchAsyncPlatformname"
                placeholder="请输入广告名称"
                style="margin-right:20px"
                @select="handleSelectPlatform"
              /> -->
            </div>
            <!-- <el-input
              v-model.trim="advertiser.adgroup_name"
              style="width: 150px"
              autofocus="true"
              placeholder="请输入广告名称"
            /> -->
            <div v-if="advertiser.type == 1" style="display: inline">
              <span class="item_title">广告名称</span>
              <el-input
                v-model.trim="advertiser.adgroup_name"
                style="width: 150px"
                placeholder="请输入广告名称"
              />
              <!-- <el-autocomplete
                v-model="advertiser.adgroup_name"
                :fetch-suggestions="querySearchAsyncPlatformnamegroup"
                placeholder="请输入广告名称"
                style="margin-right:20px"
                @select="handleSelectPlatform"
              /> -->
            </div>
            <el-button
              icon="el-icon-search"
              circle
              type="primary"
              @click="search_no"
            />
            <el-button
              style="margin-left: 50px"
              icon="el-icon-refresh-left"
              circle
              type="danger"
              @click="
                ;(advertiser.adgroup_name = null),
                  (advertiser.account_name = null),
                  (advertiser.account_id = null)
              "
            />
            <div class="choses_box">
              <div
                class="select_box"
                :class="[fullName ? 'choose_blockr' : '']"
                @click="whole"
              />
              <div v-if="fullName" @click="whole">取消全选</div>
              <div v-else @click="whole">全选</div>
            </div>
          </div>
          <div v-loading="loading" class="outerLayer_mainArea">
            <ul v-for="item in datas" :key="item.id" class="mainArea_ul">
              <li style="margin: 10px 0">
                <el-checkbox
                  v-model="item.checked"
                  :disabled="item.old == 9"
                  @change="leftcheckbox($event, item)"
                />
                <span v-if="advertiser.type == 1">
                  {{ item.adgroup_name }}/</span>
                <span
                  v-if="item.account_name !== ''"
                >({{ item.account_name }}/{{ item.account_id }})</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="buttons" style="margin: 0 10px">
          <el-button
            size="mini"
            :disabled="!leftbut"
            type="primary"
            icon="el-icon-arrow-left"
            @click="moveToleft"
          />
          <el-button
            size="mini"
            :disabled="!rightbut"
            type="primary"
            @click="moveToright"
          ><i
            class="el-icon-arrow-right el-icon--right"
          /></el-button>
        </div>
        <div class="right-panel">
          <div v-loading="loading" class="outerLayer_mainArea">
            <ul v-for="item in lastArr" :key="item.id" class="mainArea_ul">
              <!-- v-if="index >= onlyindex&&index < onlydoubl" -->
              <li
                draggable="true"
                :class="{ active: selece && item.id === selece.id }"
                style="margin: 10px 0"
              >
                <el-checkbox
                  v-model="item.checked"
                  :disabled="item.old == 9"
                  @change="rigthcheckbox($event, item)"
                />
                <span v-if="advertiser.type == 1">
                  {{ item.adgroup_name }}/</span>
                <span
                  v-if="item.account_name !== ''"
                >({{ item.account_name }}/{{ item.account_id }})</span>
              </li>
            </ul>
            <!-- <pagination-right
              style="margin-bottom: -60px;"
              class="pagination"
              :total="lastArr.length"
              :page-sizes="[10]"
              @current-change="CurrentPage"
            /> -->
          </div>
        </div>
      </div>
      <div class="page">
        <pagination-right
          class="pagination"
          :total="tableData.count"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
      <div class="butpostion">
        <el-button
          type="danger"
          plain
          @click="$router.go(-1)"
        >返回上一级</el-button>
        <el-button
          :loading="submitLoading"
          type="primary"
          plain
          @click="submit"
        >提交</el-button>
      </div>
    </div>
    <el-dialog
      title="同步账户资产"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="700px"
      append-to-body
    >
      <accoutIdDialog ref="add" @submit="submitAccout" />
    </el-dialog>
  </div>
</template>
<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import accoutIdDialog from './accoutIdDialog'
import { materialSync } from '@/api/customer.js'
import {
  account_asset_info,
  batch_update_adgroup_account
} from '@/api/releaseGroup'
import { advertiserList, adgroupsQQ, adgroupsindex } from '@/api/customer.js'
export default {
  components: {
    PaginationRight,
    accoutIdDialog
  },
  data() {
    return {
      trimmedUrl: null,
      percentage: 0,
      showModal: false,
      selectedVideoUrl: '',
      uploadFile: '',
      fileList: [],
      img_file: '',
      datas: [],
      input: '',
      selece: null,
      loading: false,
      total: null,
      pageIfon: {
        page: 1,
        page_size: 200
      },
      tableData: {},
      draggingIndex: null,
      edit: false,
      name: null,
      imgloding: false,
      message: null,
      pushdata: [],
      update: false,
      show: false,
      count: 0,
      uploadedVideoCount: 0,
      initcount: 0,
      isshow: false,
      val: null,
      lastArr: [],
      leftbut: false,
      rightbut: false,
      delaytypearr: [],
      items: {},
      parameter: {
        account_id: null
      },
      advertiser: {
        page: 1,
        page_size: 10,
        adgroup_name: null,
        account_id: null,
        type: 2
      },
      onlyindex: 0,
      onlydoubl: 10,
      // date: [
      //   this.getNowFormatDate(new Date().setMonth(new Date().getMonth() - 1)),
      //   this.getNowFormatDate(window.Date.now())
      // ], // 默认日期范围为一个月
      submitLoading: false,
      keyWordsObj: [], // 渲染关键字tag列表的数组
      inputVisible: false,
      inputValue: '', // 输入关键字
      dialogVisible: false
    }
  },
  computed: {
    fullName: function() {
      if (this.datas.length === 0) return
      // console.log('this.datas:', this.datas)
      return this.datas
        .filter((num) => {
          return num.old !== 9
        })
        .every(function(item) {
          return item.checked === true
        })
    }
  },
  created() {
    this.getDataListad()
  },
  mounted() {},
  methods: {
    materialSyncbut(row) {
      this.dialogVisible = true
      console.log(this.adqAdvertListParams.account_id)
      this.$nextTick(() => {
        // eslint-disable-next-line eqeqeq
        if (
          // eslint-disable-next-line eqeqeq
          this.$route.query.account_id == this.adqAdvertListParams.account_id
        ) {
          console.log(1)
          this.$refs.add.send(row, this.$route.query)
        } else {
          let obj = {}
          if (this.adqAdvertListParams.account_id !== '') {
            console.log(2, this.adqAdvertListParams.account_id)
            this.adqAdvertList.forEach((element) => {
              // eslint-disable-next-line eqeqeq
              if (element.account_id == this.adqAdvertListParams.account_id) {
                obj = {
                  account_id: element.account_id,
                  account_name: element.account_name
                }
              }
            })
          }
          this.$refs.add.send(row, obj)
        }
      })
    },
    async submitAccout(obj, fu) {
      await materialSync(obj)
      this.$message.success('创建成功')
      // 要判断1还是2才好刷新谁
      this.handleCloseAccout()
      fu()
    },
    handleCloseAccout() {
      this.dialogVisible = false
    },
    // getNowFormatDate(timeStamp) {
    //   var date = new Date(timeStamp)
    //   var seperator1 = '-'
    //   var year = date.getFullYear()
    //   var month = date.getMonth() + 1
    //   var strDate = date.getDate()
    //   if (month >= 1 && month <= 9) {
    //     month = '0' + month
    //   }
    //   if (strDate >= 0 && strDate <= 9) {
    //     strDate = '0' + strDate
    //   }
    //   var currentdate = year + seperator1 + month + seperator1 + strDate
    //   return currentdate
    // },
    async pullAll() {
      this.$confirm('您确定批量更新用户QQ下广告主的行为数据源?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await adgroupsQQ()
        this.$message({
          type: 'success',
          message: '拉取成功!'
        })
        this.getAdvertiserList()
      })
    },
    async querySearchAsyncPlatformid(queryString, cb) {
      this.advertiser.adgroup_name = null
      this.advertiser.account_name = null
      console.log('queryString:', queryString)
      if (queryString === null) return
      let newArr = this.datas.map((item) => {
        return {
          ...item,
          value: item.account_name,
          address: item.account_id
        }
      })
      newArr = newArr.filter((item) => queryString.includes(item.account_id))
      console.log('newArr:', newArr)
      cb(newArr)
    },
    whole() {
      if (this.fullName === true) {
        // if (this.arrs.length === this.arr.length) {
        // console.log('666')
        this.datas = this.datas.map((item) => {
          // if (item.can_checked === 1) {
          //   item.tips = false
          //   const index = this.arrs.findIndex(items => {
          //     return items.id === item.id
          //   })
          //   this.arrs.splice(index, 1)
          item.checked = false
          return {
            ...item
          }

          // }
        })
        const checkedCount = this.datas.filter(
          (item) => item.checked === true
        ).length
        if (checkedCount !== 0) {
          this.rightbut = true
        } else {
          this.rightbut = false
        }
      } else {
        // console.log('777')
        this.datas = this.datas.map((item) => {
          // console.log('item.can_checked:', item.can_checked)
          // if (item.can_checked === 1) {
          item.checked = true
          // item.old = 9
          // this.lastArr.map(re => re.id).includes(item.id) || this.lastArr.push(item)
          // const obj = JSON.parse(JSON.stringify(item))
          // obj.old = 0
          // obj.checked = false

          // this.lastArr.map(re => re.id).includes(item.id) || this.lastArr.push(obj)
          // }
          return {
            ...item
          }
        })
        const checkedCount = this.datas.filter(
          (item) => item.checked === true
        ).length
        if (checkedCount !== 0) {
          this.rightbut = true
        } else {
          this.rightbut = false
        }
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
      }
    },
    handleSelectPlatform(item) {},
    async querySearchAsyncPlatformname(queryString, cb) {
      this.advertiser.adgroup_name = null
      this.advertiser.account_id = null
      console.log('queryString:', queryString)
      if (queryString === null) return
      let newArr = this.datas.map((item) => {
        return {
          ...item,
          value: item.account_name,
          address: item.account_id
        }
      })
      newArr = newArr.filter((item) => queryString.includes(item.account_name))
      cb(newArr)
    },
    async querySearchAsyncPlatformnamegroup(queryString, cb) {
      this.advertiser.account_name = null
      this.advertiser.account_id = null
      console.log('queryString:', queryString)
      if (queryString === null) return
      let newArr = this.datas.map((item) => {
        return {
          ...item,
          value: item.adgroup_name,
          address: item.adgroup_id
        }
      })
      newArr = newArr.filter((item) => queryString.includes(item.adgroup_name))
      cb(newArr)
    },
    changeselect() {
      console.log('this.advertiser.type:', this.advertiser.type, 5555)
      this.advertiser.page = 1
      // eslint-disable-next-line eqeqeq
      if (this.advertiser.type == 1) {
        this.getDataList()
        // eslint-disable-next-line eqeqeq
      } else if (this.advertiser.type == 2) {
        this.getDataListad()
      }
      this.advertiser.account_id = ''
      this.advertiser.account_name = ''
      this.advertiser.adgroup_name = ''
      this.lastArr = []
      this.datas = []
    },
    search_no() {
      console.log('this.advertiser.type:', this.advertiser.type)
      this.advertiser.page = 1
      // eslint-disable-next-line eqeqeq
      if (this.advertiser.type == 2) {
        // this.advertiser.adgroup_name = null
        this.getDataListad()
      } else {
        // this.advertiser.account_id = null
        // this.advertiser.account_name = null
        // this.advertiser.account_name = this.advertiser.adgroup_name
        this.getDataList()
      }
      // this.lastArr = []
    },
    search_noid() {
      this.parameter.user_action_sets = []
      this.delaytypearr = []
      this.getscreen()
    },
    fetchPageSize(s) {
      this.advertiser.page_size = s
      // eslint-disable-next-line eqeqeq
      if (this.advertiser.type == 2) {
        this.getDataListad()
      } else {
        this.getDataList()
      }
    },
    fetchCurrentPage(s) {
      this.advertiser.page = s
      // eslint-disable-next-line eqeqeq
      if (this.advertiser.type == 2) {
        this.getDataListad()
      } else {
        this.getDataList()
      }
    },
    // PageSize(s) {
    //   console.log('s:=', s)
    //   this.onlyindex = (s * 10) - 10
    //   this.onlydoubl = this.onlyindex + 10
    //   // this.lastArr = s
    // },
    CurrentPage(s) {
      console.log('s:', s)
      // this.lastArr.page = s
      this.onlyindex = s * 10 - 10
      console.log(' this.onlyindex:', this.onlyindex)
      this.onlydoubl = this.onlyindex + 10
    },
    // 获取数据列表 //广告
    async getDataListad() {
      console.log(2)
      const data = await advertiserList(this.advertiser)
      this.datas = data.data.list
      this.tableData.count = data.data.total
      this.datas.map((v) => {
        v.can_checked = 1
        this.lastArr.forEach((e) => {
          if (v.id === e.id) {
            v.old = 9
          }
        })
      })
    },
    // 获取数据列表 //广告主
    async getDataList() {
      console.log(1)
      const data = await adgroupsindex(this.advertiser)
      this.datas = data.data.list
      this.tableData.count = data.data.count
      this.datas.map((v) => {
        v.can_checked = 1
        this.lastArr.forEach((e) => {
          if (v.id === e.id) {
            v.old = 9
          }
        })
      })
    },
    async getscreen() {
      if (this.parameter.account_id === null) return this.$message('请输入内容')
      const res = await account_asset_info({
        account_id: this.parameter.account_id
      })
      if (res.data.user_action_sets.length === 0) {
        this.$message('数据为空')
        return
      }
      this.delaytypearr = res.data.user_action_sets
    },
    leftcheckbox(e, item) {
      console.log('item:', item, e)
      item.checked = e
      const checkedCount = this.datas.filter(
        (item) => item.checked === true
      ).length
      // const oldCount = this.datas.filter((item) => item.old === 9).length
      // console.log('heckedCount === oldCount:', checkedCount)
      if (checkedCount !== 0) {
        this.rightbut = true
      } else {
        this.rightbut = false
      }
    },
    rigthcheckbox(e, item) {
      console.log('item:', item)
      item.checked = e
      const ble = this.lastArr.some((v) => v.checked)
      if (ble) {
        this.leftbut = true
      } else {
        this.leftbut = false
      }
    },
    moveToright() {
      const lastArr = JSON.parse(
        JSON.stringify(
          this.datas.filter((item) => item.checked === true && item.old !== 9)
        )
      )
      console.log('lastArr:', lastArr)
      this.datas.filter((item) => {
        // 标记，已经过来了
        if (item.checked) {
          item.old = 9
        }
      })
      console.log(this.items)
      lastArr.filter((item, i) => {
        i++
        const e =
          lastArr.length > 1 ? this.lastArr.length + i : this.lastArr.length + 1
        console.log('i:', e, this.lastArr.length)
        console.log('item:', item)

        // 清空true
        if (item.checked) {
          item.checked = false
          item.old = 0
        }
        console.log('item:', item)
      })
      this.lastArr.push(
        ...lastArr.map((item) => JSON.parse(JSON.stringify(item)))
      )
      this.rightbut = false
    },
    moveToleft() {
      this.lastArr.forEach((v) => {
        if (v.checked) {
          this.datas.filter((item) => {
            if (item.id === v.id) {
              item.old = 0
              item.checked = false
            }
          })
        }
      })
      this.lastArr = this.lastArr.filter((item) => item.checked !== true)
      this.leftbut = false
    },
    async submit() {
      // if (this.parameter.user_action_sets.length === 0) return this.$message('请选择用户行为数据源')
      if (this.keyWordsObj.length === 0) {
        return this.$message('请选择用户行为数据源id')
      }
      console.log('this.date:', this.date)
      // if (this.date === null) return this.$message('必须选择日期哦~')
      if (this.lastArr.length !== 0) {
        this.submitLoading = true
        console.log('this.lastArr:', this.lastArr)
        let adgroup_ids = []
        // eslint-disable-next-line eqeqeq
        if (this.advertiser.type == 2) {
          adgroup_ids = this.lastArr.map((v) => v.account_id)
        } else {
          adgroup_ids = this.lastArr.map((v) => v.adgroup_id)
        }
        console.log('adgroup_ids:', adgroup_ids)
        try {
          const res = await batch_update_adgroup_account({
            // user_action_sets_id: this.parameter.user_action_sets,
            // eslint-disable-next-line eqeqeq
            adgroup_ids: this.advertiser.type == 1 ? adgroup_ids : [],
            // eslint-disable-next-line eqeqeq
            account_ids: this.advertiser.type == 2 ? adgroup_ids : [],
            type: this.advertiser.type,
            user_action_sets_id: this.keyWordsObj
            // start_date: this.date && this.date.length ? this.date[0] : null,
            // end_date: this.date && this.date.length ? this.date[1] : null
          })
          this.submitLoading = false
          console.log('res.data:', res.data)
          // if (res.data.fail_adgroup_info.length === 0 && res.data.fail_authorization_account.length === 0) {
          // }
          this.$message.success(`操作成功`)
          this.$router.go(-1)
        } catch (error) {
          this.submitLoading = false
        }
      } else {
        return this.$message('请选择广告主或广告哦')
      }
    },
    closeModal() {
      this.selectedVideoUrl = ''
      this.showModal = false
    },
    beforeAvatarUpload(file) {
      this.uploadFile = file
    },
    handleClose(tag) {
      this.keyWordsObj.splice(this.keyWordsObj.indexOf(tag), 1)
    },
    handleInputConfirm() {
      const inputValue = this.inputValue
      if (inputValue) {
        this.keyWordsObj.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.massUpload {
  margin: 30px;
}
</style>
<style scoped lang="less">
* {
  list-style-type: none;
  box-sizing: border-box;
}
.outerLayer {
  position: relative;
  width: 99%;
  min-height: calc(100vh - 248px);
  background-color: #fff;
  padding: 10px;
  border-radius: 7px;
  box-shadow: 0px 0px 5px #ccc;
  margin: 0 auto;
  margin-top: 2px;
  margin-bottom: 2px;

  .outerLayer_titleArea {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .titleArea_left {
    }
    .titleArea_right {
      display: flex;
      align-items: center;
    }
  }

  .outerLayer_mainArea {
    // display: flex;
    // flex-wrap: wrap;
    position: relative;
    // height: 700px;
    // top: 0;
    // left: 0;
    margin: 10px;
    flex: 1;
    .mainArea_ul {
      display: flex;
      align-items: center;
      padding: 0px;
      margin: 0px;
      .ul_li {
        width: 280px;
        height: 80px;
        box-shadow: 0px 0px 2px #888686;
        border-radius: 9px;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        margin: 10px;
        position: relative;
        .badge {
          position: absolute;
          top: 0;
          right: 0;
        }

        .li_right {
          display: flex;
          flex-direction: column;
          width: 60px;
          height: 100%;
          background-color: rgb(218, 218, 218);
          align-items: center;
          justify-content: space-around;
          font-size: 13px;
          .right_icon {
            font-size: 28px;
            cursor: pointer;
            color: #888686;
            &:hover {
              color: black;
            }
          }
        }
        &.active {
          box-shadow: 0px 0px 5px #0fcf18;
          .implicit {
            display: flex;
          }
        }
        &:not(.active):hover {
          box-shadow: 0px 0px 5px #0fcf18;
          .implicit {
            display: flex;
          }
        }

        .implicit {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          box-shadow: 0px 0px 2px black;
          display: none;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background-color: #fff;
          top: 2px;
          right: 2px;
          &:hover {
            box-shadow: 0px 0px 5px #0fcf18;
          }
          i {
            font-size: 18px;
          }
        }
      }
    }
  }
}
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: #fff;
  font-size: 20px;
}
.pagination {
  position: absolute;
  bottom: 10px;
  right: 20px;
}

.modal video {
  width: 100%;
  height: 100%;
}
.ul_li.dragging {
  border: 2px dashed blue;
}
.adesr {
  display: flex;
  align-items: center;
}
.page {
  position: absolute;
  bottom: -50px;
  left: 800px;
}
.butpostion {
  position: absolute;
  bottom: -80px;
  left: 30px;
}
/* 进度条样式 */
.bacc {
  /*bacc是灰色的大背景*/
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  /*这个类的作用是把进度条放到水平垂直居中的位置*/
  .jindutiao {
    position: absolute;
    width: 150px;
    height: 150px;
    top: 50%;
    left: 50%;
    margin-left: -75px;
    margin-top: -75px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
/*更改默认的文字样式*/
.progressCircle ::v-deep .el-progress__text {
  color: #fff;
}
.shuttle-box {
  display: flex;
  // align-items: center;
}

.left-panel,
.right-panel {
  border: 2px dashed rgb(212, 212, 212);
  padding-left: 5px;
  flex: 1;
  height: 800px;
  max-height: 800px;
  overflow: auto;
}
::v-deep .el-checkbox__inner {
  border-color: #1890ff;
}
.el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #1890ff;
  border-color: #1890ff;
  cursor: not-allowed;
}
.adesr {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-top: 20px;

    .item_title {
      margin-right: 10px;
      display: inline-block;
    }
    .item_input {
      width: 200px;
    }
  }
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.choose_blockr {
  background: #409eff;
}
</style>
